<div class="example-container">
  <mat-form-field class="search-input max-30w">
    <input placeholder="Filter"
      matInput
      (keyup)="applyFilter($event)">
    </mat-form-field>
    <table mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      matSort
      class="mat-elevation-z8 mat-table-custom" id="FPControllerConfig">
      @for (item of columnsToDisplay; track item) {
        <ng-container matColumnDef="{{item}}">
          <th mat-header-cell *matHeaderCellDef>
            {{item === 'actions' || item === 'seeactions' ? 'Enabled / Disabled' : item}}
          </th>
          @if (item==='actions' && 1==1) {
            <td mat-cell *matCellDef="let element">
              @if (!getInput(element,'isEnabled')) {
                <button mat-icon-button (click)="changeElement(element, true)" matTooltip="ENABLE mode for current controller">
                  <mat-icon class="mat-icon-grey">toggle_off</mat-icon>
                </button>
              }
              @if (getInput(element,'isEnabled') === true) {
                <button mat-icon-button (click)="changeElement(element, false)" matTooltip="DISABLE mode for current controller">
                  <mat-icon class="mat-icon-green">toggle_on</mat-icon>
                </button>
              }
            </td>
          }
          @if (item==='seeactions' ) {
            <td mat-cell *matCellDef="let element">
              @if (getInput(element,'isEnabled')) {
                <div>
                  ENABLED
                </div>
              }
            </td>
          }
          @if (item!=='actions') {
            <ng-container *matCellDef="let element">
              @switch (getDataType(item)) {
                @case ('string') {
                  <td mat-cell>
                    <p [innerHTML]="getInput(element,item)"></p>
                  </td>
                }
                @case ('date') {
                  <td mat-cell>
                    <p [innerHTML]="getInput(element,item) | date:'yyyy-MM-dd HH:mm'"></p>
                  </td>
                }
              }
            </ng-container>
          }
        </ng-container>
      }

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item">
      </table>
    </div>
